import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  Divider,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  FormLabel,
  FormGroup,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { history } from "../../../components/helpers/History";
import { AppConstants } from "../../../components/constants/ApplicationConstants";

const useStyles = (theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class PatientBasicInfo extends React.Component {
  constructor(props) {
    super(props);
    console.log(JSON.stringify(this.props.basicinfo));
    this.state = {
      userid: this.props.userid,
      isEditFlow: false,
      user: {
        id: this.props.basicinfo.id,
        firstName: this.props.basicinfo.firstName,
        lastName: this.props.basicinfo.lastName,
        dob: this.props.basicinfo.dateOfBirth,
        email: this.props.basicinfo.email,
        phoneNo: this.props.basicinfo.phoneNo,
        status: this.props.basicinfo.status,
        dob: this.props.basicinfo.dateOfBirth?this.props.basicinfo.dateOfBirth:'',
        emailOptOut: this.props.basicinfo.emailOptOut?this.props.basicinfo.emailOptOut:false,
        emailOptIn: this.props.basicinfo.emailOptIn?this.props.basicinfo.emailOptIn:false,
        mailAddress: this.props.basicinfo.mailAddress?this.props.basicinfo.mailAddress:'',
        mailingOptIn: this.props.basicinfo.mailingOptIn?this.props.basicinfo.mailingOptIn:false,
        mailingOptOut: this.props.basicinfo.mailingOptOut?this.props.basicinfo.mailingOptOut:false,
        phoneNoOptIn: this.props.basicinfo.phoneNoOptIn?this.props.basicinfo.phoneNoOptIn:false,
        phoneNoOptOut: this.props.basicinfo.phoneNoOptOut?this.props.basicinfo.phoneNoOptOut:false,
        mobilePhoneNo: this.props.basicinfo.mobilePhoneNo?this.props.basicinfo.mobilePhoneNo:'',
        mobOptIn: this.props.basicinfo.mobOptIn?this.props.basicinfo.mobOptIn:false,
        mobOptOut: this.props.basicinfo.mobOptOut?this.props.basicinfo.mobOptOut:false,
        elcNotiOptIn: this.props.basicinfo.elcNotiOptIn?this.props.basicinfo.elcNotiOptIn:false,
        elcNotiOptOut: this.props.basicinfo.elcNotiOptOut?this.props.basicinfo.elcNotiOptOut:false,
      },
      submitted: false,
    };
  }

  validationObject = () => {
    var validationObject = {
      email: Yup.string()
        .email("Must be a valid email")
        .max(100)
        .required("Email is required"),
      firstName: Yup.string().max(30).required("First name is required"),
      lastName: Yup.string().max(30).required("Last name is required"),
      dob: Yup.string().max(30).required("Date of Birth is required"),
      phoneNo: Yup.number().required("Phone number required"),
      status: Yup.string()
                  .ensure()
                  .required("Status is required"),
    };
    if (this.props.isNew) {
      validationObject.password = Yup.string()
        .max(30)
        .matches(
          /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
          "Password must contain at least 8 characters, one uppercase, one number and one special case character"
        )
        .required("Password is required");
      validationObject.confirmPassword = Yup.string()
        .max(30)
        .required("Confirm password is required")
        .oneOf([Yup.ref("password"), null], "Passwords must match");
    }
    return validationObject;
  };
  render() {
    const classes = this.props.classes;
    const { registering } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
        <Container component="main" maxWidth="md">
          <CssBaseline />
          <>
            <Formik
              enableReinitialize
              initialValues={{
                id: this.state.user.id,
                firstName: this.state.user.firstName,
                lastName: this.state.user.lastName,
                email: this.state.user.email,
                dob: this.state.user.dob,
                phoneNo: this.state.user.phoneNo,
                password: this.state.user.password,
                confirmPassword: this.state.user.confirmPassword,
                userRole: "ROLE_PATIENT",
                status: this.state.user.status,
                emailOptOut: this.state.user.emailOptOut,
                emailOptIn: this.state.user.emailOptIn,
                mailAddress: this.state.user.mailAddress,
                mailingOptIn: this.state.user.mailingOptIn,
                mailingOptOut: this.state.user.mailingOptOut,
                phoneNoOptIn: this.state.user.phoneNoOptIn,
                phoneNoOptOut: this.state.user.phoneNoOptOut,
                mobilePhoneNo: this.state.user.mobilePhoneNo,
                mobOptIn: this.state.user.mobOptIn,
                mobOptOut: this.state.user.mobOptOut,
                elcNotiOptIn: this.state.user.elcNotiOptIn,
                elcNotiOptOut: this.state.user.elcNotiOptOut,
              }}
              validationSchema={Yup.object().shape(this.validationObject())}
              onSubmit={(values, { setSubmitting }) => {
                this.setState({ submitted: true });
                this.props.updateBasicInfo(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit} noValidate name="form">
                  <Box sx={{ mb: 3 }}>
                    <Typography component="h3" variant="body1">
                      Patient Info
                    </Typography>
                  </Box>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        error={Boolean(touched.firstName && errors.firstName)}
                        fullWidth
                        helperText={touched.firstName && errors.firstName}
                        label="First Name"
                        margin="normal"
                        name="firstName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.firstName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        error={Boolean(touched.lastName && errors.lastName)}
                        fullWidth
                        helperText={touched.lastName && errors.lastName}
                        label="Last Name"
                        margin="normal"
                        name="lastName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.lastName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <TextField
                          error={Boolean(touched.dob && errors.dob)}
                          helperText={touched.dob && errors.dob}
                          id="dob"
                          name="dob"
                          label="Date of birth"
                          type="date"
                          margin="normal"
                          className={classes.textField}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.dob}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        variant="outlined"
                        margin="normal"
                        className={classes.formControl}
                        fullWidth
                      >
                        <InputLabel htmlFor="status-label">Status</InputLabel>
                        <Select
                          native
                          value={values.status}
                          error={Boolean(touched.status && errors.status)}
                          helperText={touched.status && errors.status}
                          label="Status"
                          inputProps={{
                            name: "status",
                            id: "status-label",
                          }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option aria-label="None" value="" />
                          {AppConstants.USER_STATUS_LIST.map((element) => {
                            return (
                              <option value={element.value}>
                                {element.label}
                              </option>
                            );
                          })}
                        </Select>
                        {errors.status && touched.status && (
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.status}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    {this.props.isNew ? (
                      <React.Fragment>
                        <Grid item xs={12} md={6}>
                          <TextField
                            error={Boolean(touched.password && errors.password)}
                            fullWidth
                            helperText={touched.password && errors.password}
                            label="Password"
                            margin="normal"
                            name="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.password}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            error={Boolean(
                              touched.confirmPassword && errors.confirmPassword
                            )}
                            fullWidth
                            helperText={
                              touched.confirmPassword && errors.confirmPassword
                            }
                            label="Confirm password"
                            margin="normal"
                            name="confirmPassword"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.confirmPassword}
                            variant="outlined"
                          />
                        </Grid>
                      </React.Fragment>
                    ) : null}

                    <Grid container border={10} spacing={2}>
                      <Grid item xs={12}>
                        {" "}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          component="h3"
                          variant="body1"
                          color="primary"
                        >
                          Communication channel
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(touched.email && errors.email)}
                          fullWidth
                          helperText={touched.email && errors.email}
                          label="Email Address"
                          margin="normal"
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.email}
                          variant="outlined"
                          disabled={!this.props.isNew}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Email Address
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                          <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="emailOptIn"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.emailOptIn}
                                  checked={values.emailOptIn}
                                  error={Boolean(touched.emailOptIn && errors.emailOptIn)}
                                  helperText={touched.emailOptIn && errors.emailOptIn}
                                />
                              }
                              label="Opt In"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="emailOptOut"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.emailOptOut}
                                  checked={values.emailOptOut}
                                  error={Boolean(touched.emailOptOut && errors.emailOptOut)}
                                  helperText={touched.emailOptOut && errors.emailOptOut}
                                />
                              }
                              label="Opt Out"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.mailAddress && errors.mailAddress
                          )}
                          fullWidth
                          helperText={touched.mailAddress && errors.mailAddress}
                          label="Mailing Address"
                          margin="normal"
                          name="mailAddress"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.mailAddress}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Mailing Address
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                          <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="mailingOptIn"
                                  onBlur={handleBlur}
                                  checked={values.mailingOptIn}
                                  onChange={handleChange}
                                  value={values.mailingOptIn}
                                  error={Boolean(touched.mailingOptIn && errors.mailingOptIn)}
                                  helperText={touched.mailingOptIn && errors.mailingOptIn}
                                />
                              }
                              label="Opt In"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="mailingOptOut"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  checked={values.mailingOptOut}
                                  value={values.mailingOptOut}
                                  error={Boolean(touched.mailingOptOut && errors.mailingOptOut)}
                                  helperText={touched.mailingOptOut && errors.mailingOptOut}
                                />
                              }
                              label="Opt Out"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(touched.phoneNo && errors.phoneNo)}
                          fullWidth
                          helperText={touched.phoneNo && errors.phoneNo}
                          label="Phone Number"
                          margin="normal"
                          name="phoneNo"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.phoneNo}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                          Phone Number
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                          <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="phoneNoOptIn"
                                  onBlur={handleBlur}
                                  checked={values.phoneNoOptIn}
                                  onChange={handleChange}
                                  value={values.phoneNoOptIn}
                                  error={Boolean(touched.phoneNoOptIn && errors.phoneNoOptIn)}
                                  helperText={touched.phoneNoOptIn && errors.phoneNoOptIn}
                                />
                              }
                              label="Opt In"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="phoneNoOptOut"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.phoneNoOptOut}
                                  checked={values.phoneNoOptOut}
                                  error={Boolean(touched.phoneNoOptOut && errors.phoneNoOptOut)}
                                  helperText={touched.phoneNoOptOut && errors.phoneNoOptOut}
                                />
                              }
                              label="Opt Out"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.mobilePhoneNo && errors.mobilePhoneNo
                          )}
                          fullWidth
                          helperText={
                            touched.mobilePhoneNo && errors.mobilePhoneNo
                          }
                          label="Mobile Phone Number"
                          margin="normal"
                          name="mobilePhoneNo"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.mobilePhoneNo}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Mobile phone number
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                          <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="mobOptIn"
                                  checked={values.mobOptIn}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.mobOptIn}
                                  error={Boolean(touched.mobOptIn && errors.mobOptIn)}
                                  helperText={touched.mobOptIn && errors.mobOptIn}
                                />
                              }
                              label="Opt In"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="mobOptOut"
                                  checked={values.mobOptOut}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.mobOptOut}
                                  error={Boolean(touched.mobOptOut && errors.mobOptOut)}
                                  helperText={touched.mobOptOut && errors.mobOptOut}
                                />
                              }
                              label="Opt Out"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>

                    </Grid>
                    
                    <Grid item xs={12} md={12}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                          <Typography
                          component="h3"
                          variant="body1"
                          color="primary"
                        >
                          Electronic Notification
                        </Typography>
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                          <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="elcNotiOptIn"
                                  onBlur={handleBlur}
                                  checked={values.elcNotiOptIn}
                                  onChange={handleChange}
                                  value={values.elcNotiOptIn}
                                  error={Boolean(touched.elcNotiOptIn && errors.elcNotiOptIn)}
                                  helperText={touched.elcNotiOptIn && errors.elcNotiOptIn}
                                />
                              }
                              label="Opt In"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  color="primary"
                                  name="elcNotiOptOut"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  checked={values.elcNotiOptOut}
                                  value={values.elcNotiOptOut}
                                  error={Boolean(touched.elcNotiOptOut && errors.elcNotiOptOut)}
                                  helperText={touched.elcNotiOptOut && errors.elcNotiOptOut}
                                />
                              }
                              label="Opt Out"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>



                  </Grid>

                  <div className={classes.buttons}>
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </>
        </Container>
      </>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(PatientBasicInfo);
